export default {
  inventoryLocation: {
    order: 1,
    label: 'Location',
    dataKey: 'inventoryLocation.name',
    isText: true
  },
  item: {
    order: 2,
    label: 'Item',
    dataKey: 'item.name',
    isText: true
  },
  description: {
    order: 3,
    label: 'Description',
    dataKey: 'item.description',
    width: 300,
    isText: true
  },
  maxCount: {
    order: 4,
    label: 'Max Quantity',
    dataKey: 'item.maxCount',
    width: 120
  },
  minCount: {
    order: 5,
    label: 'Min Quantity',
    dataKey: 'item.minCount',
    width: 120
  },
  remainingQuantity: {
    order: 6,
    label: 'Quantity',
    dataKey: 'remainingQuantity',
    width: 120
  },
  reOrderQuantity: {
    order: 7,
    label: 'Order',
    dataKey: 'reOrderQuantity',
    width: 120
  },
  reOrderCost: {
    order: 8,
    label: 'Reorder Cost',
    dataKey: 'reOrderCost',
    width: 120
  }
};
